import { useLoading, Puff } from '@agney/react-loading';
const Loader = () => {
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        loaderProps: {
            style: { color:"#00a86b" }
          },
        indicator: <Puff width="128" />,
    });
    return (
        <section {...containerProps } style={{minHeight:"100vh",display:"flex",justifyContent:"center"}}>
            { indicatorEl }
        </section >
      );
}

export default Loader;